import PageComponent from '../base/PageComponent';
import 'slick-carousel';
import '../libs/popup';
import PropertyCarouselPopup from './PropertyCarouselPopup';

export default class PropertyCarousel extends PageComponent
{

    constructor(domElement) {
        super(domElement);
        this.mobileNavBreakPoint = 1500;
    }

    init() {
        this.CarouselPopup();
        this.setupCarousel();
        this.setupThumbnail();
        //this.clickPause();
    }

    clickPause(){
        this.addEvent('.button-pause', 'click', e => this.togglePause(e));
    }

    togglePause() {
        let controller = $('.button-pause');

        if(controller.hasClass('paused')){
            $('.property-detail__slideshow .property-detail__slides').slick('slickPlay');
            controller.removeClass('paused');
        }
        else {
            $('.property-detail__slideshow .property-detail__slides').slick('slickPause');
            controller.addClass('paused');
        }
    }

    setupCarousel() {
        if (this.getSlides() > 1) {
            $('.property-detail__slideshow .property-detail__slides').slick({
                slide: '.slide__item',
                asNavFor: '.property-detail__slideshow .property-detail__thumbnails-inner',
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: false,
                pauseOnHover: true,
                dots: false,
                infinite: true,
                arrows: false,
                centerMode: true,
                centerPadding: '20%',
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: true
            });
        }
    }

    setupThumbnail() {
        $('.property-detail__slideshow .property-detail__thumbnails-inner').slick({
            slidesToShow: 6,
            asNavFor: '.property-detail__slideshow .property-detail__slides',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            infinite: true,
            centerPadding: '0',
            prevArrow: '<div class="icon-arrow-top arrow-prev"></div>',
            nextArrow: '<div class="icon-arrow-top arrow-next"></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 460,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });
    }

    getSlides() {
        return this.childElements('.slide__item').length;
    }

    CarouselPopup() {
        this.addEvent('.slide__item', 'click', e => this.onCarouselClick(e));
    }

    onCarouselClick(e) {
        let windowWidth = $(window).width();

        //only show popup if they click on the currently active slide
        if (!$(e.currentTarget).hasClass('slick-current')) return;

        //if (windowWidth <= this.mobileNavBreakPoint) {
            var index = $(e.target).closest('div').data('slick-index');
            this.popup = new PropertyCarouselPopup(index);
            this.popup.init();
        //}
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyCarousel.js